import React, { Component } from "react";
import { connect } from "react-redux";
import { setCartTotals, setCartItems, toggleLoading } from "../../Redux/slices/cart";
import { client } from "../../../App";
import { UPDATE_ITEM_QTY } from "../../apollo";

const mapDispatchToProps = dispatch => {
    return {
        setCartTotals: payload => dispatch(setCartTotals(payload)),
        setCartItems: payload => dispatch(setCartItems(payload)),
        toggleLoading: payload => dispatch(toggleLoading(payload))
    };
}

class ItemQuantity extends Component {
    constructor() {
        super();
        this.changeQty = this.changeQty.bind(this);
    }
    
    changeQty(qtyChange) {
        this.props.toggleLoading(true);

        client.mutate({
            mutation: UPDATE_ITEM_QTY,
            variables: {
                key: this.props.cartKey,
                qty: (this.props.quantity + qtyChange)
            }
        }).then(resp => {
            this.props.setCartTotals({
                total: resp.data.updateItemQuantities.cart.total,
                subTotal: resp.data.updateItemQuantities.cart.subtotal,
                tax: resp.data.updateItemQuantities.cart.totalTax
            });

            this.props.setCartItems({
                itemCount: resp.data.updateItemQuantities.cart.contents.itemCount,
                items: resp.data.updateItemQuantities.cart.contents.nodes.filter((item) => {
                    return item.product !== null;
                }).map(item => {
                    return {
                        id: item.variation.node.databaseId,
                        cartKey: item.key,
                        quantity: item.quantity,
                        mainImageSrc: item.product.node.image.mediaItemUrl,
                        name: item.product.node.name,
                        price: item.variation.node.price,
                        size: item.variation.node.attributes.nodes[0].value
                    };
                })
            });

            this.props.toggleLoading(false);
        })
    }

    render() {
        return <div className="qty-count-wrap">
            <div className="decrement qty-box" onClick={() => this.changeQty(-1)}>-</div>
            <span className="qty-count">{this.props.quantity}</span>
            <div className="increment qty-box" onClick={() => this.changeQty(1)}>+</div>
        </div>
    }
}

export default connect(null, mapDispatchToProps)(ItemQuantity);
